import { v4 as uuid } from 'uuid';
import {
  ADD_MESSAGE, CLEAR_MESSAGES, REMOVE_MESSAGE, DISMISS_MESSAGE,
} from './messageReducer';

export const MESSAGE_TYPE_ERROR = 'error';
export const MESSAGE_TYPE_SUCCESS = 'success';

export const addErrorMessage = message => ({
  type: ADD_MESSAGE, message, messageType: MESSAGE_TYPE_ERROR, id: uuid(),
});
export const addSuccessMessage = message => ({
  type: ADD_MESSAGE, message, messageType: MESSAGE_TYPE_SUCCESS, id: uuid(),
});
export const removeMessage = id => ({ type: REMOVE_MESSAGE, id });
export const dismissMessage = id => ({ type: DISMISS_MESSAGE, id });
export const clearMessages = () => ({ type: CLEAR_MESSAGES });
